import { SectionInterface, SectionNomenklature, TireRackItemI } from "../../../../store/types/store";
import { GetItemReturnArr } from "./SpecificationGeneral";

type itemType = {
    name: string;
    price: number;
};

const addItemInArr = (arr: GetItemReturnArr[], index: number, item: itemType) => {
    if (index === -1) {
        arr.push({
            name: item.name,
            count: 1,
            price: item.price,
            totalPrice: item.price,
        });
    } else {
        arr[index].count++;
        arr[index].totalPrice += item.price;
    }
};

export const getItem = (sectionsList: SectionInterface[], parts?: any[]) => {
    const returnItems: GetItemReturnArr[] = [];
    const returnElements: GetItemReturnArr[] = [];

    sectionsList.forEach((sections) => {
        sections.items.forEach((item) => {
            const indexItem = returnItems.findIndex((arr) => arr?.name === item.name);
            addItemInArr(returnItems, indexItem, item);
            if (item.brackets.left.isVisible) {
                item.brackets.left.elements.forEach((element) => {
                    const indexElement = returnElements.findIndex((arr) => arr?.name === element.name);
                    addItemInArr(returnElements, indexElement, element);
                });
            }
            if (item.brackets.right.isVisible) {
                item.brackets.right.elements.forEach((element) => {
                    const indexElement = returnElements.findIndex((arr) => arr?.name === element.name);
                    addItemInArr(returnElements, indexElement, element);
                });
            }
            const partsFiltered = item.parts.filter((element) => {
                return item.edges?.filter((el) => el.bitrixId === element.bitrixId) !== undefined;
            });

            partsFiltered.forEach((element) => {
                // Для штанг используем имя из BITRIX_OFFER_ID вместо element.name
                const partFromBitrix = parts?.find((p: any) => p.BITRIX_OFFER_ID === element.bitrixId);
                const elementName = partFromBitrix?.NAME || element.name;

                const indexElement = returnElements.findIndex((arr) => arr?.name === elementName);
                const elementWithCorrectName = { ...element, name: elementName };
                addItemInArr(returnElements, indexElement, elementWithCorrectName);
            });
        });
    });
    return { returnItems, returnElements };
};

export const getGuide = (sectionsNomenklature: SectionNomenklature[]) => {
    let returnGuideArr: GetItemReturnArr[] = [
        {
            name: "Горизонтальная направляющая 480",
            count: 0,
            price: sectionsNomenklature[0].horizontal.price480 ? sectionsNomenklature[0].horizontal.price480 : 0,
            totalPrice: 0,
        },
        {
            name: "Горизонтальная направляющая 600",
            count: 0,
            price: sectionsNomenklature[0].horizontal.price600 ? sectionsNomenklature[0].horizontal.price600 : 0,
            totalPrice: 0,
        },
        {
            name: "Горизонтальная направляющая 800",
            count: 0,
            price: sectionsNomenklature[0].horizontal.price800 ? sectionsNomenklature[0].horizontal.price800 : 0,
            totalPrice: 0,
        },
        {
            name: "Горизонтальная направляющая 1200",
            count: 0,
            price: sectionsNomenklature[0].horizontal.price1200 ? sectionsNomenklature[0].horizontal.price1200 : 0,
            totalPrice: 0,
        },
        {
            name: "Вертикальная направляющая 480",
            count: 0,
            price: sectionsNomenklature[0].vertical.price480 ? sectionsNomenklature[0].vertical.price480 : 0,
            totalPrice: 0,
        },
        {
            name: "Вертикальная направляющая 600",
            count: 0,
            price: sectionsNomenklature[0].vertical.price600 ? sectionsNomenklature[0].vertical.price600 : 0,
            totalPrice: 0,
        },
        {
            name: "Вертикальная направляющая 800",
            count: 0,
            price: sectionsNomenklature[0].vertical.price800 ? sectionsNomenklature[0].vertical.price800 : 0,
            totalPrice: 0,
        },
        {
            name: "Вертикальная направляющая 1200",
            count: 0,
            price: sectionsNomenklature[0].vertical.price1200 ? sectionsNomenklature[0].vertical.price1200 : 0,
            totalPrice: 0,
        },
    ];
    const connectors: GetItemReturnArr[] = [
        {
            name: "Соединитель",
            count: 0,
            price: sectionsNomenklature[0].connectorPrice ? sectionsNomenklature[0].connectorPrice : 0,
            totalPrice: 0,
        },
    ];
    sectionsNomenklature.forEach((section) => {
        connectors[0].count += section.connector;
        connectors[0].totalPrice += section.connector * (section.connectorPrice ? section.connectorPrice : 0);
        if (section.horizontal[480]) {
            returnGuideArr[0].count += section.horizontal[480];
            returnGuideArr[0].totalPrice +=
                section.horizontal[480] *
                (sectionsNomenklature[0].horizontal.price480 ? sectionsNomenklature[0].horizontal.price480 : 0);
        }
        if (section.horizontal[600]) {
            returnGuideArr[1].count += section.horizontal[600];
            returnGuideArr[1].totalPrice +=
                section.horizontal[600] *
                (sectionsNomenklature[0].horizontal.price600 ? sectionsNomenklature[0].horizontal.price600 : 0);
        }
        if (section.horizontal[800]) {
            returnGuideArr[2].count += section.horizontal[800];
            returnGuideArr[2].totalPrice +=
                section.horizontal[800] *
                (sectionsNomenklature[0].horizontal.price800 ? sectionsNomenklature[0].horizontal.price800 : 0);
        }
        if (section.horizontal[1200]) {
            returnGuideArr[3].count += section.horizontal[1200];
            returnGuideArr[3].totalPrice +=
                section.horizontal[1200] *
                (sectionsNomenklature[0].horizontal.price1200 ? sectionsNomenklature[0].horizontal.price1200 : 0);
        }
        if (section.vertical[480]) {
            returnGuideArr[4].count += section.vertical[480];
            returnGuideArr[4].totalPrice +=
                section.vertical[480] *
                (sectionsNomenklature[0].vertical.price480 ? sectionsNomenklature[0].vertical.price480 : 0);
        }
        if (section.vertical[600]) {
            returnGuideArr[5].count += section.vertical[600];
            returnGuideArr[5].totalPrice +=
                section.vertical[600] *
                (sectionsNomenklature[0].vertical.price600 ? sectionsNomenklature[0].vertical.price600 : 0);
        }
        if (section.vertical[800]) {
            returnGuideArr[6].count += section.vertical[800];
            returnGuideArr[6].totalPrice +=
                section.vertical[800] *
                (sectionsNomenklature[0].vertical.price800 ? sectionsNomenklature[0].vertical.price800 : 0);
        }
        if (section.vertical[1200]) {
            returnGuideArr[7].count += section.vertical[1200];
            returnGuideArr[7].totalPrice +=
                section.vertical[1200] *
                (sectionsNomenklature[0].vertical.price1200 ? sectionsNomenklature[0].vertical.price1200 : 0);
        }
    });
    returnGuideArr = returnGuideArr.filter((guide) => guide.count > 0);

    return { returnGuideArr, connectors };
};

export const getTireRackItems = (tireRacks: TireRackItemI[]): GetItemReturnArr[] => {
    const tireRackMap = new Map<string, { count: number; price: number }>();
    const partsMap = new Map<string, { count: number; price: number }>();

    tireRacks.forEach((tireRack) => {
        // Добавляем саму стойку, используем nomenclature name если есть, иначе 3D object name
        const key = tireRack.nameNomenkl || tireRack.name;
        const existing = tireRackMap.get(key);
        const price = tireRack.pricing?.base_price || 0; // Используем base_price для самой стойки
        if (existing) {
            existing.count += 1;
            existing.price = price;
        } else {
            tireRackMap.set(key, { count: 1, price });
        }

        // Добавляем элементы из PARTS
        if (tireRack.parts) {
            tireRack.parts.forEach((part) => {
                const partKey = part.name;
                const existingPart = partsMap.get(partKey);
                const partPrice = part.price || 0;
                if (existingPart) {
                    existingPart.count += 1;
                    existingPart.price = partPrice;
                } else {
                    partsMap.set(partKey, { count: 1, price: partPrice });
                }
            });
        }
    });

    // Объединяем стойки и части
    const result: GetItemReturnArr[] = [];
    
    // Добавляем стойки
    tireRackMap.forEach((data, name) => {
        result.push({
            name,
            count: data.count,
            price: data.price,
            totalPrice: data.count * data.price,
        });
    });

    // Добавляем части
    partsMap.forEach((data, name) => {
        result.push({
            name,
            count: data.count,
            price: data.price,
            totalPrice: data.count * data.price,
        });
    });

    return result;
};

export interface GeneralSpecification {
    items: GetItemReturnArr[];
    elements: GetItemReturnArr[];
    guides: GetItemReturnArr[];
    connectors: GetItemReturnArr[];
    tireRacks: GetItemReturnArr[];
}

export const getSpecificationGeneral = (
    sectionsList: SectionInterface[],
    sectionsNomenklature: SectionNomenklature[],
    tireRacks: TireRackItemI[] = []
): GeneralSpecification => {
    const { returnItems, returnElements } = getItem(sectionsList);
    const { returnGuideArr, connectors } = getGuide(sectionsNomenklature);
    const tireRackItems = getTireRackItems(tireRacks);

    return {
        items: returnItems,
        elements: returnElements,
        guides: returnGuideArr,
        connectors,
        tireRacks: tireRackItems,
    };
};
